import { SELECT_RETURN_CODE } from '../constants/ActionTypes'

export default function selectReturnCode(returnCode, lineNumber) {
    return {
        type: SELECT_RETURN_CODE,
        returnCode,
        lineNumber
    }
}
